import { Modal } from '../../../components/ui/Modal/Modal';
import { Button } from '../../../components/ui/Button/Button';

export interface BankDetailsUpdateModalProps {
  open: boolean;
  /** Names of the differing fields (never values), e.g. ['account_number']. */
  fields: readonly string[];
  loading?: boolean;
  onYes: () => void;
  onNo: () => void;
  /** Abort the save altogether and return to the form. */
  onBack: () => void;
}

const FIELD_LABEL: Record<string, string> = {
  account_name: 'account name',
  account_number: 'account number',
  sort_code: 'sort code',
};

/**
 * Batch 7b — shown when this receipt's bank details differ from the ones
 * stored on the linked customer. "Yes" is the default / primary action.
 * Only field names are shown: stored values are admin-only.
 */
export function BankDetailsUpdateModal({
  open,
  fields,
  loading = false,
  onYes,
  onNo,
  onBack,
}: BankDetailsUpdateModalProps): JSX.Element {
  const labels = fields.map((f) => FIELD_LABEL[f] ?? f).join(', ');
  return (
    <Modal
      open={open}
      onClose={onBack}
      title="Update the customer's stored bank details?"
      size="sm"
      preventClose={loading}
      footer={
        <>
          <Button variant="secondary" onClick={onBack} disabled={loading}>
            Back to form
          </Button>
          <Button variant="secondary" onClick={onNo} disabled={loading}>
            No, keep stored
          </Button>
          <Button variant="primary" onClick={onYes} loading={loading}>
            Yes, update
          </Button>
        </>
      }
    >
      <p>
        The bank details on this receipt ({labels}) differ from the ones stored on the
        customer&apos;s record. Update the customer&apos;s stored bank details to match this
        receipt? The change is recorded in the customer&apos;s bank-detail history.
      </p>
    </Modal>
  );
}
